// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form-module--wrapper--2T1tf","inputWrapp":"Form-module--inputWrapp--32X3q","inputRow":"Form-module--inputRow--MHngU","agree":"Form-module--agree--2fK-D"};